// @needs-native-review — best-effort translation
import type { Translations } from '../types';

export const hi: Translations = {
  'meta.gameTitle': 'Luminary',

  'howto.title': 'कैसे खेलें',
  'howto.pieces.heading': 'टुकड़े',
  'howto.pieces.source': 'स्रोत',
  'howto.pieces.mirror': 'दर्पण',
  'howto.pieces.switch': 'स्विच',
  'howto.pieces.exit': 'निकास',
  'howto.pieces.wall': 'दीवार',
  'howto.controls.heading': 'नियंत्रण',
  'howto.controls.clickSlot.line1': 'खाने पर क्लिक करें',
  'howto.controls.clickSlot.line2': 'दर्पण रखें',
  'howto.controls.dragMirror.line1': 'दर्पण को खींचें',
  'howto.controls.dragMirror.line2': 'घुमाएँ',
  'howto.controls.rightClick.line1': 'राइट-क्लिक',
  'howto.controls.rightClick.line2': 'दर्पण हटाएँ',
  'howto.controls.hint': 'माउस व्हील: 1° का सूक्ष्म घुमाव।   दर्पण टैप: 15° का घुमाव।',
  'howto.objective.line1': 'हर स्विच को रोशन करें — निकास का ताला अपने आप खुल जाता है।',
  'howto.objective.line2': 'फिर निकास पर क्लिक करें। जितने कम दर्पणों से हो सके, हल करें।',

  'howtoColor.title': 'रंग और प्रिज़्म',
  'howtoColor.pieces.heading': 'नए टुकड़े',
  'howtoColor.pieces.prism': 'प्रिज़्म',
  'howtoColor.pieces.redSwitch': 'लाल स्विच',
  'howtoColor.pieces.yellowSwitch': 'पीला स्विच',
  'howtoColor.pieces.whiteSwitch': 'सफ़ेद स्विच',
  'howtoColor.how.heading': 'ये कैसे काम करते हैं',
  'howtoColor.how.line1': 'एक सफ़ेद किरण एक साथ लाल, हरी और नीली रोशनी ले जाती है।',
  'howtoColor.how.line2':
    'एक प्रिज़्म सफ़ेद रोशनी को अपनी तीनों भुजाओं से तीन रंगीन किरणों में बाँट देता है।',
  'howtoColor.how.line3': 'रखे हुए प्रिज़्म पर क्लिक करके उसका इनपुट चेहरा घुमाएँ।',
  'howtoColor.switches.line1': 'स्विच पर रंगीन बिंदु दिखते हैं — यही उन्हें चाहिए वाला रंग है।',
  'howtoColor.switches.line2': 'पीले स्विच (लाल + हरे बिंदु) को दोनों रंग एक साथ चाहिए।',
  'howtoColor.switches.line3': 'सफ़ेद स्विच (तीनों रंग) को लाल, हरा और नीला एक साथ चाहिए।',

  'options.hints.label': 'पहेलियों में संकेत कोण दिखाएँ',
  'options.hints.help': 'हर परावर्तन पर आपाती और परावर्तित किरण के बीच का कोण दिखाता है।',

  'level.01-intro.title': 'नमस्ते, रोशनी',
  'level.02-two-mirrors.title': 'दो मोड़',
  'level.03-corner.title': 'रास्ते में दीवार',
  'level.04-two-targets.title': 'दो निशाने',
  'level.05-tight.title': 'तंग',
  'level.06-hello-color.title': 'नमस्ते, रंग',
  'level.07-pick-a-side.title': 'एक पक्ष चुनें',
  'level.08-yellow.title': 'पीला',
  'level.09-magenta.title': 'मैजेंटा',
  'level.10-spectrum.title': 'स्पेक्ट्रम',

  // PuzzleScene
  'puzzle.itemCounter': '{used}/{optimal}',
  'puzzle.hint.angleType.right': 'समकोण',
  'puzzle.hint.angleType.acute': 'न्यून',
  'puzzle.hint.angleType.obtuse': 'अधिक',
  'puzzle.hint.label': '{angle}°\n{type}',
};
